<script>
  import { useForm } from '@inertiajs/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Field from '../../components/ui/Field.svelte';
  import Button from '../../components/ui/Button.svelte';

  let { platforms = [] } = $props();

  // platforms is a static server prop. Pass a data function so useForm reads the
  // initial platform when it initializes, not as a tracked top-level reference.
  const form = useForm(() => ({
    social_account: { platform: platforms[0] || '' },
  }));

  function submit() {
    // The server responds with an external auth URL (inertia_location), so the
    // browser does a full visit to the network's OAuth screen.
    form.post('/social_accounts');
  }
</script>

<AppLayout title="Connect an account">
  <div class="max-w-md">
    <Card>
      <p class="text-sm text-secondary-500 mb-6">
        Pick a network and you'll be sent to it to authorize. Once you approve,
        the account shows up here automatically.
      </p>
      <form onsubmit={(e) => { e.preventDefault(); submit(); }} class="flex flex-col gap-4">
        {#if form.errors.base}
          <div class="rounded-xl border border-red-200 bg-red-50 text-red-700 px-4 py-3 text-sm">
            {form.errors.base}
          </div>
        {/if}
        <Field label="Platform" id="platform" error={form.errors.platform}>
          {#snippet children(describedBy)}
            <select id="platform" class="input capitalize" bind:value={form.social_account.platform} aria-describedby={describedBy}>
              {#each platforms as p}
                <option value={p} class="capitalize">{p}</option>
              {/each}
            </select>
          {/snippet}
        </Field>
        <div class="flex items-center gap-3 mt-2">
          <Button type="submit" disabled={form.processing}>
            {form.processing ? 'Redirecting…' : 'Continue'}
          </Button>
          <Button href="/social_accounts" variant="ghost">Cancel</Button>
        </div>
      </form>
    </Card>
  </div>
</AppLayout>
